module.exports = __webpack_public_path__ + "img/Logo-agc.37038ead.png";